import { useCallback } from 'react';

import { useAssetModalRightPanel } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';
import { useEditMode } from '~/components/EditMode/EditModeProvider';

export const useEditModeStatus = () => {
  const { assetTransformStatus, setAssetTransformStatus, currentEditModeOption } = useEditMode();
  const { restoreLastRightPanelTab, closeRightPanel } = useAssetModalRightPanel();

  const setStatusIdle = useCallback(() => {
    setAssetTransformStatus('idle');
    restoreLastRightPanelTab();
  }, [setAssetTransformStatus, restoreLastRightPanelTab]);

  const setStatusInProgress = useCallback(() => {
    setAssetTransformStatus('in-progress');
    if (currentEditModeOption?.id !== 'prompt') {
      closeRightPanel();
    }
  }, [closeRightPanel, currentEditModeOption?.id, setAssetTransformStatus]);

  const setStatusCompleted = useCallback(() => {
    setAssetTransformStatus('completed');
    if (currentEditModeOption?.id === 'prompt') {
      restoreLastRightPanelTab();
    } else {
      closeRightPanel();
    }
  }, [closeRightPanel, currentEditModeOption?.id, setAssetTransformStatus, restoreLastRightPanelTab]);

  const setStatusSaving = useCallback(() => {
    setAssetTransformStatus('saving');
  }, [setAssetTransformStatus]);

  const setStatusFailed = useCallback(() => {
    setAssetTransformStatus('failed');
  }, [setAssetTransformStatus]);

  const setStatusIdleRetry = useCallback(() => {
    setAssetTransformStatus('idle-retry');
  }, [setAssetTransformStatus]);

  return {
    status: assetTransformStatus,
    setStatusIdle,
    setStatusInProgress,
    setStatusCompleted,
    setStatusSaving,
    setStatusFailed,
    setStatusIdleRetry,
  };
};
